import {getMethod} from '~/api'

async function get(request, cancelToken) {
    return await getMethod('/proxy/searchTours', request, cancelToken)
}

export {get}
